import AmexResyCreditEligibleVenues from './AmexResyCreditEligibleVenues';

export default AmexResyCreditEligibleVenues;
